import React, {useCallback, useEffect, useState} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import FileUpload from "../../../../components-new/general/FileUpload";
import config from "../../../../config";

import Translate from "../../../../components/Translate";
import {addNotification as addNotificationAction} from "../../../../services/notification/action";
import {updateUserData as updateUserDataAction} from "../../../../services/user/action";
import {updateUser as updateUserApi,} from "../../../../services/user/api";
import "./index.css";
import {generalModalStyles} from "../../../../utils/General";
import Modal from '../../../../components-new/ui/Modal';
import Colors from "../../../../utils/Colors";
import Input from "../../../../components-new/form/Input";
import EmailIcon from "../../../../assets/icons/EmailIcon";
import PhoneCallIcon from "../../../../assets/icons/PhoneCallIcon";
import PersonIcon from "../../../../assets/icons/PersonIcon";

const styles = {
    wrapper: {
        padding: "40px",
        display: "flex",
        flexDirection: "row",
    },
    title: {
        color: Colors.blueLite,
        marginBottom: "40px",
    },
    firstName: {
        width: "100%",
        marginBottom: "20px",
    },
};

const UserProfileModal = ({
                              user,
                              close,
                              isOpen,
                              onRequestClose,
                              addNotification,
                              updateUserData,
                          }) => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        contactNumber: "",
        thumbUrl: "",
    });

    useEffect(() => {
        if (isOpen && user) {
            setFormData({
                firstName: user.firstName || "",
                lastName: user.lastName || "",
                email: user.email || "",
                contactNumber: user.contactNumber || "",
                thumbUrl: user.thumbUrl || "",
            });
        }
    }, [isOpen, user])

    const handleChange = (name) => (value) => {
        setFormData((prev) => ({...prev, [name]: value}));

        if (name === 'thumbUrl') {
            let userData = getUserDataFromState()
            userData.thumbUrl = value
            updateUserApi(userData)
                .then((userUpdatedData) => {
                    updateUserData(userUpdatedData);
                    addNotification("userInfoUpdated", config.notificationLevels.success);
                })
                .catch(() => {
                    addNotification("somethingWentWrong", config.notificationLevels.error);
                });
        }
    };

    const handleDelete = (name) => () => {
        setFormData((prev) => ({...prev, [name]: ""}));
        if (name === 'thumbUrl') {
            let userData = getUserDataFromState()
            userData.thumbUrl = "";
            updateUserApi(userData)
                .then((userUpdatedData) => {
                    updateUserData(userUpdatedData);
                    addNotification("userInfoUpdated", config.notificationLevels.success);
                })
                .catch(() => {
                    addNotification("somethingWentWrong", config.notificationLevels.error);
                });
        }
    };

    const getUserDataFromState = useCallback(() => {
        const {firstName, lastName, email, contactNumber, thumbUrl} = formData;
        return {
            firstName,
            lastName,
            email,
            contactNumber: contactNumber != null ? contactNumber : "no number",
            thumbUrl: thumbUrl != null ? thumbUrl : "",
        };
    }, [formData]);

    const saveUserData = useCallback(() => {
        const userData = getUserDataFromState();

        const doUpdateUser = () => {
            if (user.canChangeHimselfInfo) {
                return updateUserApi(userData)
                    .then((userUpdatedData) => {
                        updateUserData(userUpdatedData);
                        close();
                        addNotification("userInfoUpdated", config.notificationLevels.success);
                    })
                    .catch(() => {
                        addNotification("somethingWentWrong", config.notificationLevels.error);
                    });
            }
            return Promise.resolve();
        };
        doUpdateUser();
    }, [
        formData,
        getUserDataFromState,
        user,
        updateUserData,
        addNotification,
        close,
    ]);

    const {
        firstName,
        lastName,
        contactNumber,
        email,
        thumbUrl,
    } = formData;

    return (
        <Modal
            closeTimeoutMS={config.closeTimeoutMS}
            isOpen={isOpen}
            style={generalModalStyles.menuItemModalStyles}
            onRequestClose={onRequestClose}
            onSubmit={saveUserData}
            onCancel={close}
            title={<Translate text="profile"/>}
            description={<Translate text="profileDescription"/>}
            headerIcon={<PersonIcon height={20} width={20} fill="var(--ds-fg-secondary)"/>}
            headerSeparator
            footerSeparator
        >
            <div>
                <div
                    className={user.canChangeHimselfInfo ? "" : "disabled-div"}
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        marginBottom: "20px",
                        gap: '24px'
                    }}
                >
                    <div
                        style={{display: "flex", justifyContent: "center", flex: "0 0 auto"}}
                    >
                        <FileUpload
                            windowSize={120}
                            imgSize={110}
                            svgSize={50}
                            progressSize={120}
                            handleDelete={handleDelete("thumbUrl")}
                            handleChange={handleChange("thumbUrl")}
                            image={thumbUrl}
                        />
                    </div>

                    <div style={{minWidth: 0, flex: "1 1 240px"}}>
                        <div
                            style={styles.firstName}
                        >
                            <Input
                                label={<Translate text="firstName"/>}
                                maxLength={15}
                                style={{width: "100%", height: "40px"}}
                                value={firstName}
                                onChange={(e) => handleChange("firstName")(e.target.value)}
                            />
                        </div>

                        <div
                            className={user.canChangeHimselfInfo ? "" : "disabled-div"}
                            style={styles.lastName}
                        >
                            <Input
                                label={<Translate text="lastName"/>}
                                controlled
                                maxLength={15}
                                style={{width: "100%", height: "40px"}}
                                value={lastName}
                                onChange={(e) => handleChange("lastName")(e.target.value)}
                            />
                        </div>
                    </div>

                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                    }}
                >
                    <div className={'title-and-input'}>
                        <Input
                            label={<Translate text="phoneNumber"/>}
                            controlled
                            style={{width: "100%", height: "40px"}}
                            value={contactNumber}
                            onChange={(e) => handleChange("contactNumber")(e.target.value)}
                            leadingIcon={(<PhoneCallIcon width={20} height={20}/>)}
                        />
                    </div>

                    <div className={'title-and-input'}>
                        <Input
                            label={<Translate text="email"/>}
                            controlled
                            disabled
                            style={{
                                width: "100%",
                                height: "40px",
                            }}
                            value={email}
                            leadingIcon={(
                                <EmailIcon
                                    width={20} height={20}
                                />)}
                        />
                    </div>

                </div>

            </div>
        </Modal>
    );
};

UserProfileModal.propTypes = {
    user: PropTypes.object.isRequired,
    close: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired,
    updateUserData: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func,
};

const mapStateToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = {
    addNotification: addNotificationAction,
    updateUserData: updateUserDataAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileModal);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/UserProfileModal.jsx